module.exports = function() {
  return new Worker(__webpack_public_path__ + "c59a7278d8ad94eae913.worker.js");
};